import { P } from '../world/player';
/* ============================================================
   模組與核心強化
   ============================================================ */
/* **2026-08-01 轉向倖存者類之後這些模組的去向**（M6 的判定）：

   原本 roadmap 寫「12 個模組拆散：一半升格成獨立武裝、一半降級成武裝的等級效果」。
   前半做了 —— 池子六把裡有五把是從這裡升格的（地雷、軌道光柱、跳彈、斬波、旋刃）。

   **後半改了做法。** 「降級成武裝的等級效果」在新設計下不成立：
   機體的三把武裝（主武裝 + 兩個主動技）**沒有等級**，它們是機體的固定身分。
   所以這些行為改裝改成 **M10「主武器」局外等級的解鎖內容** ——
   局外把主武器升到 n 級就解鎖對應的改裝，那正好是 M10 那個部位缺的實質內容
   （不然它只會是「+射速」這種沒有記憶點的東西）。

   在 M10 做完之前，`P.mod` 會維持全部是 null，下面這些行為分支不會被觸發。
   **它們是待接線的內容，不是死碼。** */
export var MODULES = [
  { id: 'pierce', slot: 'primary', w: 'vulcan', n: '貫穿彈芯', d: '子彈穿透 3 個目標，每次穿透傷害 −25%' },
  { id: 'chain', slot: 'primary', w: 'vulcan', n: '跳彈迴路', d: '命中後彈向 9 單位內的下一個目標，最多 3 次', t2: true },
  { id: 'cluster', slot: 'mid', w: 'missile', n: '連鎖分裂', d: '飛彈爆炸後分裂成 3 枚追擊彈' },
  { id: 'mines', slot: 'mid', w: 'missile', n: '磁暴地雷', d: '改為在周圍佈設 6 顆感應地雷' },
  { id: 'focus', slot: 'ult', w: 'beam', n: '定點鑽擊', d: '光束改為鎖定單體照射，傷害隨照射時間遞增' },
  { id: 'orbital', slot: 'ult', w: 'beam', n: '軌道支援', d: '改為召喚 3 道軌道光柱，落在敵人最密處', t2: true },
  { id: 'wide', slot: 'primary', w: 'blade', n: '擴幅刀刃', d: '斬擊範圍 +45%，附帶強力擊退' },
  { id: 'pulse', slot: 'primary', w: 'blade', n: '衝擊波', d: '每次斬擊射出一道穿透性斬波', t2: true },
  { id: 'after', slot: 'mid', w: 'dashSlash', n: '殘影連斬', d: '突進終點追加一次範圍斬擊' },
  { id: 'hook', slot: 'mid', w: 'dashSlash', n: '引力鉤索', d: '突進前將 14 單位內的敵人拉向自己', t2: true },
  { id: 'expand', slot: 'ult', w: 'vortex', n: '擴張場域', d: '旋刃半徑隨時間擴張至兩倍' },
  { id: 'absorb', slot: 'ult', w: 'vortex', n: '吸能迴路', d: '旋刃每次命中回復結構', t2: true }
];
/* CORES（4 種純數值核心）在 M3 移除，理由與 UPGRADES 相同，見 ui/progress.ts 的檔頭。
   保留這段註解是為了讓之後讀 git log 的人知道它去哪了。 */
var _REMOVED_CORES = [
  { id: 'c1', n: '核心超載', d: '全武裝傷害 +40%', f: function () { P.s.atkDmg *= 1.4; P.s.midDmg *= 1.4; P.s.ultDmg *= 1.4; } },
  { id: 'c2', n: '反應爐擴充', d: '結構上限 +60、護盾 +40，並全部回復', f: function () { P.hpMax += 60; P.shMax += 40; P.hp = P.hpMax; P.sh = P.shMax; } },
  { id: 'c3', n: '時間壓縮', d: '所有冷卻 −25%、射速 +20%', f: function () { P.s.midCdMax *= 0.75; P.s.ultCdMax *= 0.75; P.s.atkRate *= 1.2; } },
  { id: 'c4', n: '臨界共振', d: '爆擊率 +18%、爆擊傷害 +80%', f: function () { P.s.crit += 0.18; P.s.critMul += 0.8; } }
];
